import { getMetricSpec } from './metrics';
import { tKey } from '@strength/i18n';
export function validateWorkoutForPublish(workout, metrics) {
    const errors = new Map();
    if (workout.sections.length === 0) {
        // we should prevent this for workouts in the
        // block workout task processing but we'll
        // validate here too to ensure we don't publish a workout without sections
        errors.set(workout.workoutId, [tKey('workoutMustHaveOneSection')]);
    }
    const sectionNames = new Set();
    for (const section of workout.sections) {
        if (sectionNames.has(section.name)) {
            errors.set(section.workoutSectionId, [tKey('sectionNameMustBeUnique')]);
        }
        sectionNames.add(section.name);
        if (section.entries.length === 0)
            continue;
        const allExercises = [];
        for (const entry of section.entries) {
            if (entry.__type === 'WorkoutExercise') {
                allExercises.push(entry);
            }
            else {
                allExercises.push(...entry.exercises.map((e) => e.exercise));
                // Specifically do not check for supersets with 0 exercises, since they would not be visible in the UI
                // We filter these out during when getting the "relevant edits" for a publish
                if (entry.__type === 'WorkoutSuperset' &&
                    entry.exercises.length === 1 &&
                    entry.exercises[0]) {
                    errors.set(entry.exercises[0].workoutExerciseId, [
                        tKey('supersetMustHaveTwoExercises'),
                    ]);
                }
            }
        }
        for (const exercise of allExercises) {
            const { sets, metrics: exerciseMetrics } = exercise;
            const exerciseErrors = [];
            // exercise must have at least one set
            if (sets.length === 0) {
                exerciseErrors.push(tKey('exerciseMustHaveOneSet'));
            }
            else {
                // only check for metrics if there are sets
                const hasMetrics = exerciseMetrics.length > 0;
                const hasOnlySetMetric = hasMetrics &&
                    exerciseMetrics.length === 1 &&
                    exerciseMetrics[0]?.metricType === 'sets';
                // set must have at least one non-'set' metric
                if (!hasMetrics || hasOnlySetMetric) {
                    exerciseErrors.push(tKey('exerciseMustHaveOneMetric'));
                }
            }
            if (exerciseErrors.length > 0) {
                errors.set(exercise.workoutExerciseId, exerciseErrors);
            }
            for (const set of sets) {
                for (const exerciseMetric of exerciseMetrics) {
                    const metric = metrics.find((m) => m.id === exerciseMetric.metricId);
                    if (!metric) {
                        errors.set(getSetExerciseMetricId(set, exerciseMetric), [
                            tKey('metricIsNotValid', { metric: exerciseMetric.metricName }),
                        ]);
                        continue;
                    }
                    const matchingSetMetric = set.metrics.find((m) => m.metricId === exerciseMetric.metricId);
                    if (!matchingSetMetric) {
                        continue;
                    }
                    const spec = getMetricSpec(metric);
                    const parseResult = spec.schema.safeParse(matchingSetMetric.input);
                    if (!parseResult.success) {
                        errors.set(getSetExerciseMetricId(set, exerciseMetric), [
                            tKey('metricHasInvalidValue', {
                                metric: exerciseMetric.metricName,
                            }),
                        ]);
                    }
                }
            }
        }
    }
    if (errors.size === 0) {
        return null;
    }
    return errors;
}
export function getSetExerciseMetricId(workoutSet, exerciseMetric) {
    return `${workoutSet.workoutSetId}-${exerciseMetric.workoutExerciseMetricId}`;
}
//# sourceMappingURL=publish.js.map